import React, {useState, Fragment, useRef} from 'react'

import {PlusIcon, SearchIcon, XCircleIcon} from '@heroicons/react/solid'
import {Dialog, Transition} from '@headlessui/react'
import {ExclamationIcon} from '@heroicons/react/outline'

const tabs = [
    {id: 0, name: 'Scrim Search'},
    {id: 1, name: 'Scrim Offers'},
    {id: 2, name: 'Upcoming Scrims'},
    {id: 3, name: 'Rating'},
    {id: 4, name: 'Team'}
]

const people = [
    {
        team: 'Futbolist',
        name: 'qRaxs#4970',
        rating: 4,
        date: "20.01.2022",
        time: "18:00 +03",
        map: "All Maps",
        image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60',
    },
    {
        team: 'Zort Esports',
        name: 'Tropik#4970',
        rating: 5,
        date: "20.01.2022",
        time: "17:00 +03",
        map: "Icebox, Bind",
        image: 'https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60',
    },
    {
        team: 'Fire Flux Esports',
        name: 'souhcNi#4970',
        rating: 5,
        date: "20.01.2022",
        time: "16:00 +03",
        map: "Ascent, Breeze, Icebox",
        image: 'https://images.unsplash.com/photo-1520813792240-56fc4a3765a7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60',
    },
    {
        team: 'BBL Esports',
        name: 'pAura#4970',
        rating: 3,
        date: "20.01.2022",
        time: "15:00 +03",
        map: "All Maps",
        image: 'https://images.unsplash.com/photo-1498551172505-8ee7ad69f235?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60',
    },
    {
        team: 'Zart Esports',
        name: 'Deniro#4970',
        rating: 5,
        time: "14:00 +03",
        map: "Bind, Ascent, Haven",
        date: "20.01.2022",
        image: 'https://images.unsplash.com/photo-1532417344469-368f9ae6d187?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60',
    }
]

const team = {
    game: "VALORANT",
    // ...
}

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Scrims() {
    const [type, setType] = useState(0)

    const [open, setOpen] = useState(false)

    const [isCreating, setCreating] = useState(false)

    const [isAlertOpen, setAlertOpen] = useState(false)

    const cancelButtonRef = useRef(null)

    return (
        <div className="flex flex-col gap-y-6 h-full">
            <div className="sm:hidden">
                <label htmlFor="tabs" className="sr-only">
                    Select a tab
                </label>

                <select
                    id="tabs"
                    name="tabs"
                    className="w-full pl-3 pr-10 py-2 text-base border-gray-300 transition-colors focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                    defaultValue={tabs.find((tab) => tab.id === type).name}
                    onChange={e => {
                        setType(tabs.find(tab => tab.name === e.target.value).id ?? 0)

                        setCreating(false)
                    }}
                >
                    {tabs.map((tab) => (
                        <option key={tab.name}>{tab.name}</option>
                    ))}
                </select>

                {type === 0 && !isCreating && (
                    <a onClick={() => {
                        setCreating(true)
                    }}
                       className="text-sm w-full flex items-center justify-center font-medium cursor-pointer text-primary mt-4 transition-colors hover:text-indigo-700">
                        Create a Request
                    </a>
                )}
            </div>

            <div className="hidden sm:block">
                <div className="border-b border-gray-200">
                    <nav className="-mb-px flex justify-between" aria-label="Tabs">
                        <div className="flex gap-x-8 items-center justify-center">
                            {tabs.map((tab) => (
                                <a
                                    key={tab.name}
                                    className={classNames(
                                        tab.id === type
                                            ? 'border-indigo-500 text-indigo-600'
                                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                                        'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm cursor-pointer'
                                    )}
                                    onClick={() => {
                                        setType(tab.id)

                                        setCreating(false)
                                    }}
                                    aria-current={tab.id === type ? 'page' : undefined}
                                >
                                    {tab.name}
                                </a>
                            ))}
                        </div>


                        {type === 0 && !isCreating && (
                            <a onClick={() => {
                                setCreating(true)
                            }}
                               className="text-sm font-medium cursor-pointer text-primary mt-4 transition-colors hover:text-indigo-700">
                                Create a Request
                            </a>
                        )}
                    </nav>
                </div>
            </div>

            {type === 0 && !isCreating && (
                <div className="flex flex-col">
                    <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div className="shadow-sm overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                    <tr>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Team
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Rating
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Date
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Time
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Map
                                        </th>
                                        <th scope="col" className="relative px-6 py-3">
                                            <span className="sr-only">Make Offer</span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                    {people.map((person) => (
                                        <tr key={person.nickname}>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="flex items-center">
                                                    <div className="flex-shrink-0 h-10 w-10">
                                                        <img className="h-10 w-10 rounded-full" src={person.image}
                                                             alt=""/>
                                                    </div>
                                                    <div className="ml-4">
                                                        <div
                                                            className="text-sm font-medium text-gray-900">{person.team}</div>
                                                        <div className="text-sm text-gray-500">{person.name}</div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                            <span
                                                className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${person.rating <= 3 ? "bg-yellow-100 text-yellow-800" : "bg-green-100 text-green-800"}`}>
                                                {person.rating}/5
                                            </span>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-gray-900">{person.date}</div>
                                            </td>


                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{person.time}</td>

                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{person.map}</td>

                                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                <a href="#" className="text-indigo-600 hover:text-indigo-900">
                                                    Make Offer
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {type === 0 && isCreating && (

                <div className="pt-0 sm:pt-8">
                    <div className="md:grid md:grid-cols-3 md:gap-6">
                        <div className="md:col-span-1">
                            <div className="px-4 sm:px-0">
                                <h3 className="text-lg font-medium leading-6 text-gray-900">Create a Scrim
                                    Request</h3>
                                <p className="mt-1 text-sm text-gray-600">
                                    Choose the date, time and other details.
                                </p>
                            </div>
                        </div>
                        <div className="md:col-span-2">
                            <form action="#" method="POST">
                                <div className="sm:rounded-md sm:overflow-hidden">
                                    <div className="px-4 bg-white space-y-6">
                                        <div className="grid grid-cols-3 gap-6">
                                            <div className="col-span-3 sm:col-span-2 mt-8 sm:mt-0">
                                                <label htmlFor="region"
                                                       className="block text-sm font-medium text-gray-700">
                                                    Region
                                                </label>

                                                <select
                                                    name="region"
                                                    id="region"
                                                    className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 pr-10 py-2 pl-3 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                    defaultValue="Europe"
                                                >
                                                    <option>Europe</option>
                                                    <option>Turkey</option>
                                                </select>
                                            </div>

                                            <div className="col-span-3 sm:col-span-2">
                                                <label htmlFor="date"
                                                       className="block text-sm font-medium text-gray-700">
                                                    Pick a Date*
                                                </label>

                                                <input
                                                    required
                                                    type="date"
                                                    name="date"
                                                    id="date"
                                                    className="transition-colors mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                />
                                            </div>

                                            <div className="col-span-3 sm:col-span-2">
                                                <label htmlFor="time"
                                                       className="block text-sm font-medium text-gray-700">
                                                    Pick a Time*
                                                </label>

                                                <input
                                                    required
                                                    type="time"
                                                    name="time"
                                                    id="time"
                                                    className="transition-colors mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                />
                                            </div>

                                            {team.game === "VALORANT" && (
                                                <div className="col-span-3 sm:col-span-2">
                                                    <label htmlFor="map"
                                                           className="block text-sm font-medium text-gray-700">
                                                        Map Selection
                                                    </label>

                                                    <fieldset className="space-y-5">
                                                        <legend className="sr-only">Maps</legend>
                                                        <div className="relative flex items-start">
                                                            <div className="flex items-center h-5">
                                                                <input
                                                                    id="comments"
                                                                    aria-describedby="comments-description"
                                                                    name="comments"
                                                                    type="checkbox"
                                                                    className="focus:ring-0 transition-colors h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                                                />
                                                            </div>
                                                            <div className="ml-3 text-sm">
                                                                <label htmlFor="comments"
                                                                       className="font-medium text-gray-700">
                                                                    All
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="relative flex items-start">
                                                            <div className="flex items-center h-5">
                                                                <input
                                                                    id="candidates"
                                                                    aria-describedby="candidates-description"
                                                                    name="candidates"
                                                                    type="checkbox"
                                                                    className="focus:ring-0 transition-colors h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                                                />
                                                            </div>
                                                            <div className="ml-3 text-sm">
                                                                <label htmlFor="candidates"
                                                                       className="font-medium text-gray-700">
                                                                    Haven
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="relative flex items-start">
                                                            <div className="flex items-center h-5">
                                                                <input
                                                                    id="offers"
                                                                    aria-describedby="offers-description"
                                                                    name="offers"
                                                                    type="checkbox"
                                                                    className="focus:ring-0 transition-colors h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                                                />
                                                            </div>
                                                            <div className="ml-3 text-sm">
                                                                <label htmlFor="offers"
                                                                       className="font-medium text-gray-700">
                                                                    Bind
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="relative flex items-start">
                                                            <div className="flex items-center h-5">
                                                                <input
                                                                    id="offers"
                                                                    aria-describedby="offers-description"
                                                                    name="offers"
                                                                    type="checkbox"
                                                                    className="focus:ring-0 transition-colors h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                                                />
                                                            </div>
                                                            <div className="ml-3 text-sm">
                                                                <label htmlFor="offers"
                                                                       className="font-medium text-gray-700">
                                                                    Split
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="relative flex items-start">
                                                            <div className="flex items-center h-5">
                                                                <input
                                                                    id="offers"
                                                                    aria-describedby="offers-description"
                                                                    name="offers"
                                                                    type="checkbox"
                                                                    className="focus:ring-0 transition-colors h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                                                />
                                                            </div>
                                                            <div className="ml-3 text-sm">
                                                                <label htmlFor="offers"
                                                                       className="font-medium text-gray-700">
                                                                    Ascent
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="relative flex items-start">
                                                            <div className="flex items-center h-5">
                                                                <input
                                                                    id="offers"
                                                                    aria-describedby="offers-description"
                                                                    name="offers"
                                                                    type="checkbox"
                                                                    className="focus:ring-0 transition-colors h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                                                />
                                                            </div>
                                                            <div className="ml-3 text-sm">
                                                                <label htmlFor="offers"
                                                                       className="font-medium text-gray-700">
                                                                    Icebox
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="relative flex items-start">
                                                            <div className="flex items-center h-5">
                                                                <input
                                                                    id="offers"
                                                                    aria-describedby="offers-description"
                                                                    name="offers"
                                                                    type="checkbox"
                                                                    className="focus:ring-0 transition-colors h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                                                />
                                                            </div>
                                                            <div className="ml-3 text-sm">
                                                                <label htmlFor="offers"
                                                                       className="font-medium text-gray-700">
                                                                    Breeze
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="relative flex items-start">
                                                            <div className="flex items-center h-5">
                                                                <input
                                                                    id="offers"
                                                                    aria-describedby="offers-description"
                                                                    name="offers"
                                                                    type="checkbox"
                                                                    className="focus:ring-0 transition-colors h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                                                />
                                                            </div>
                                                            <div className="ml-3 text-sm">
                                                                <label htmlFor="offers"
                                                                       className="font-medium text-gray-700">
                                                                    Fracture
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </fieldset>
                                                </div>
                                            )}

                                            <div className="col-span-3 sm:col-span-2">
                                                <label htmlFor="contact"
                                                       className="block text-sm font-medium text-gray-700">
                                                    Contact (Riot ID or Discord ID)*
                                                </label>

                                                <input
                                                    required
                                                    type="text"
                                                    name="contact"
                                                    id="contact"
                                                    className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                />
                                            </div>

                                            <div className="col-span-3 sm:col-span-2 sm:pb-0">
                                                <div className="flex justify-end">
                                                    <button
                                                        onClick={() => {
                                                            setCreating(false)
                                                        }}
                                                        type="button"
                                                        className="py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50"
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        className="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white transition-colors bg-primary hover:bg-indigo-600"
                                                    >
                                                        Create
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {type === 1 && (
                <div className="flex flex-col">
                    <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div className="shadow-sm overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                    <tr>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Team
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Rating
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Date
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Time
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Map
                                        </th>
                                        <th scope="col" className="relative px-6 py-3">
                                            <span className="sr-only">Reject Offer</span>
                                        </th>
                                        <th scope="col" className="relative px-6 py-3">
                                            <span className="sr-only">Make Offer</span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                    {people.map((person) => (
                                        <tr key={person.nickname}>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="flex items-center">
                                                    <div className="flex-shrink-0 h-10 w-10">
                                                        <img className="h-10 w-10 rounded-full" src={person.image}
                                                             alt=""/>
                                                    </div>
                                                    <div className="ml-4">
                                                        <div
                                                            className="text-sm font-medium text-gray-900">{person.team}</div>
                                                        <div className="text-sm text-gray-500">{person.name}</div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                            <span
                                                className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${person.rating <= 3 ? "bg-yellow-100 text-yellow-800" : "bg-green-100 text-green-800"}`}>
                                                {person.rating}/5
                                            </span>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-gray-900">{person.date}</div>
                                            </td>


                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{person.time}</td>

                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{person.map}</td>

                                            <td className="py-4 whitespace-nowrap text-right text-sm font-medium">
                                                <a href="#" className="text-red-500 hover:text-red-700">
                                                    Reject Offer
                                                </a>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                <a href="#" className="text-indigo-600 hover:text-indigo-800">
                                                    Accept Offer
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {type === 2 && people.length === 0 && (
                <div className="text-center translate-y-32">
                    <svg className="mx-auto h-12 w-12 text-gray-400" xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 20 20" fill="currentColor">
                        <path
                            d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"/>
                    </svg>

                    <h3 className="mt-4 text-sm font-medium text-gray-900">No upcoming scrims</h3>

                    <p className="mt-2 text-sm text-gray-500">Get started by finding a new scrim.</p>

                    <div className="mt-6">
                        <button
                            type="button"
                            className="inline-flex items-center px-4 py-2 border border-transparent transition-colors shadow-sm text-sm font-medium rounded-md text-white bg-primary hover:bg-indigo-600"
                            onClick={() => {
                                setType(0)

                                setCreating(false)
                            }}
                        >
                            <SearchIcon className="-ml-1 mr-2 h-5 w-5" aria-hidden="true"/>
                            Find Scrim
                        </button>
                    </div>
                </div>
            )}

            {type === 2 && people.length !== 0 && (
                <div className="flex flex-col">
                    <div
                        className={`fixed bottom-5 z-10 left-5 sm:left-auto right-5 transition-all ${isAlertOpen ? "visible opacity-100" : "invisible opacity-0"}`}>
                        <div className="flex items-center rounded-md bg-red-50 p-3 max-w-max">
                            <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true"/>

                            <div className="ml-3">
                                <h3 className="text-sm font-medium text-red-800 mb-0">Scrim is cancelled. If you think
                                    we made a mistake, please contact us.</h3>
                            </div>
                        </div>
                    </div>

                    <Transition.Root show={open} as={Fragment}>
                        <Dialog as="div" className="fixed z-10 inset-0 overflow-y-auto" initialFocus={cancelButtonRef}
                                onClose={setOpen}>
                            <div
                                className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:p-0">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0"
                                    enterTo="opacity-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                >
                                    <Dialog.Overlay
                                        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
                                </Transition.Child>

                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                >
                                    <div
                                        className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                                        <div>
                                            <div
                                                className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
                                                <ExclamationIcon className="h-6 w-6 text-red-600" aria-hidden="true"/>
                                            </div>
                                            <div className="mt-3 text-center sm:mt-5">
                                                <Dialog.Title as="h3"
                                                              className="text-lg leading-6 font-medium text-gray-900">
                                                    Scrim Cancellation
                                                </Dialog.Title>
                                                <div className="mt-2">
                                                    <p className="text-sm text-gray-500">
                                                        If you cancel the scrim now, the opponent team will be notified
                                                        via email. Are you sure you want to cancel this scrim?
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">

                                            <button
                                                type="button"
                                                className="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 outline-none text-base text-gray-700 transition-colors hover:bg-gray-50 sm:mt-0 sm:col-start-1 sm:text-sm"
                                                onClick={() => setOpen(false)}
                                                ref={cancelButtonRef}
                                            >
                                                Go Back
                                            </button>

                                            <button
                                                type="button"
                                                className="w-full inline-flex justify-center mt-2 sm:mt-0 rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-500 text-base text-white transition-colors hover:bg-red-600 sm:col-start-2 sm:text-sm"
                                                onClick={() => {
                                                    setOpen(false)

                                                    if (!isAlertOpen) {
                                                        setAlertOpen(true)

                                                        setTimeout(() => {
                                                            setAlertOpen(false)
                                                        }, 3000)
                                                    }
                                                }}
                                            >
                                                Confirm Cancellation
                                            </button>
                                        </div>
                                    </div>
                                </Transition.Child>
                            </div>
                        </Dialog>
                    </Transition.Root>

                    <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div className="shadow-sm overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                    <tr>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Team
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Rating
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Date
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Time
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Map
                                        </th>
                                        <th scope="col" className="relative px-6 py-3">
                                            <span className="sr-only">Make Offer</span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                    {people.map((person) => (
                                        <tr key={person.nickname}>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="flex items-center">
                                                    <div className="flex-shrink-0 h-10 w-10">
                                                        <img className="h-10 w-10 rounded-full" src={person.image}
                                                             alt=""/>
                                                    </div>
                                                    <div className="ml-4">
                                                        <div
                                                            className="text-sm font-medium text-gray-900">{person.team}</div>
                                                        <div className="text-sm text-gray-500">{person.name}</div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                            <span
                                                className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${person.rating <= 3 ? "bg-yellow-100 text-yellow-800" : "bg-green-100 text-green-800"}`}>
                                                {person.rating}/5
                                            </span>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-gray-900">{person.date}</div>
                                            </td>


                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{person.time}</td>

                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{person.map}</td>

                                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                <a onClick={() => {
                                                    setOpen(true)
                                                }} href="#" className="text-red-600 hover:text-red-900">
                                                    Cancel
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {type === 3 && (
                <div className="flex flex-col">
                    <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div className="shadow-sm overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                    <tr>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Date
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Time
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Team
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Map
                                        </th>
                                        <th
                                            scope="col"
                                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Rating
                                        </th>
                                        <th scope="col" className="relative px-6 py-3">
                                            <span className="sr-only">Rate the Opponent</span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                    {people.map((person) => (
                                        <tr key={person.nickname}>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-gray-900">{person.date}</div>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{person.time}</td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="flex items-center">
                                                    <div className="flex-shrink-0 h-10 w-10">
                                                        <img className="h-10 w-10 rounded-full" src={person.image}
                                                             alt=""/>
                                                    </div>
                                                    <div className="ml-4">
                                                        <div
                                                            className="text-sm font-medium text-gray-900">{person.team}</div>
                                                        <div className="text-sm text-gray-500">{person.name}</div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{person.map}</td>

                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <span
                                                    className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${person.rating <= 3 ? "bg-yellow-100 text-yellow-800" : "bg-green-100 text-green-800"}`}>
                                                    {person.rating}/5
                                                </span>
                                            </td>

                                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                <a href="#" className="text-indigo-600 hover:text-indigo-900">
                                                    Rate the Opponent
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {type === 4 && people.length === 0 && (
                <div className="text-center translate-y-32">
                    <svg
                        className="mx-auto h-12 w-12 text-gray-400"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                    >
                        <path
                            vectorEffect="non-scaling-stroke"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                        />
                    </svg>
                    <h3 className="mt-4 text-sm font-medium text-gray-900">You don’t have a team.</h3>
                    <p className="mt-2 text-sm text-gray-500">Get started by creating a team.</p>
                    <div className="mt-6">
                        <button
                            type="button"
                            className="inline-flex items-center px-4 py-2 border transition-colors border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary hover:bg-indigo-600"
                        >
                            <PlusIcon className="-ml-1 mr-2 h-5 w-5" aria-hidden="true"/>
                            Create a Team
                        </button>
                    </div>
                </div>
            )}

            {type === 4 && people.length !== 0 && (

                <div className="pt-0 sm:pt-8">
                    <div className="md:grid md:grid-cols-3 md:gap-6">
                        <div className="md:col-span-1">
                            <div className="px-4 sm:px-0">
                                <h3 className="text-lg font-medium leading-6 text-gray-900">Team Profile</h3>
                                <p className="mt-1 text-sm text-gray-600">
                                    This information will be displayed publicly so be careful what you share.
                                </p>
                            </div>
                        </div>
                        <div className="md:col-span-2 mt-8 sm:mt-0">
                            <form action="#" method="POST">
                                <div className="sm:rounded-md sm:overflow-hidden">
                                    <div className="px-4 bg-white space-y-6">
                                        <div className="grid grid-cols-3 gap-6">
                                            <div className="col-span-3 sm:col-span-2">
                                                <label className="block text-sm font-medium text-gray-700">Team Logo</label>

                                                <div className="mt-2 flex items-center">
                                                    <span
                                                        className="inline-block h-12 w-12 rounded-full overflow-hidden bg-gray-100">
                                                        <svg className="h-full w-full text-gray-300"
                                                             fill="currentColor" viewBox="0 0 24 24">
                                                            <path
                                                                d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"/>
                                                        </svg>
                                                    </span>
                                                    <button
                                                        type="button"
                                                        className="ml-5 py-2 px-3 border border-gray-300 rounded-md text-sm leading-4 font-medium text-gray-700 transition-colors hover:bg-gray-50"
                                                    >
                                                        Change
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="ml-3 py-2 px-3 border bg-red-500 border-red-300 rounded-md text-sm leading-4 font-medium text-white transition-colors hover:bg-red-700"
                                                    >
                                                        Delete
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="col-span-3 sm:col-span-2">
                                                <label htmlFor="game"
                                                       className="block text-sm font-medium text-gray-700">
                                                    Game
                                                </label>

                                                <select
                                                    name="game"
                                                    id="game"
                                                    className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 pr-10 py-2 pl-3 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                    defaultValue="VALORANT"
                                                >
                                                    <option>VALORANT</option>
                                                    <option>League of Legends</option>
                                                    <option>Wild Rift</option>
                                                </select>
                                            </div>

                                            <div className="col-span-3 sm:col-span-2">
                                                <label htmlFor="team-name"
                                                       className="block text-sm font-medium text-gray-700">
                                                    Team Name*
                                                </label>

                                                <input
                                                    required
                                                    type="text"
                                                    name="team-name"
                                                    id="team-name"
                                                    className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                    placeholder="MaZe Clan"
                                                />
                                            </div>

                                            <div className="col-span-3 sm:col-span-2">
                                                <label htmlFor="contact"
                                                       className="block text-sm font-medium text-gray-700">
                                                    Contact*
                                                </label>

                                                <input
                                                    required
                                                    type="text"
                                                    name="contact"
                                                    id="contact"
                                                    className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                    placeholder="Discord#3535"
                                                />
                                            </div>

                                            <div className="col-span-3 sm:col-span-2">
                                                <label htmlFor="game-id"
                                                       className="block text-sm font-medium text-gray-700">
                                                    Game ID*
                                                </label>

                                                <input
                                                    required
                                                    type="text"
                                                    name="game-id"
                                                    id="game-id"
                                                    className="mt-2 focus:ring-indigo-500 transition-colors focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                                                    placeholder="Riot ID or Steam ID"
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <label htmlFor="team-members"
                                                   className="block text-sm font-medium text-gray-700">
                                                Team Members (Riot ID or Steam ID)
                                            </label>

                                            <textarea
                                                id="team-members"
                                                name="team-members"
                                                rows={3}
                                                className="mt-2 p-2 resize-none h-32 transition-colors focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md"
                                                placeholder={`Tropik#VLR\nTropik#VLR\nTropik#VLR\nTropik#VLR\nTropik#VLR`}
                                                defaultValue={''}
                                            />

                                            <p className="mt-2 text-sm text-gray-500">
                                                List of team members
                                            </p>
                                        </div>

                                        <div>
                                            <label htmlFor="team-description"
                                                   className="block text-sm font-medium text-gray-700">
                                                Team Description
                                            </label>

                                            <textarea
                                                id="team-description"
                                                name="team-description"
                                                rows={3}
                                                className="mt-2 p-2 resize-none h-24 transition-colors focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md"
                                                placeholder="We are a great team, established in 1789."
                                                defaultValue={''}
                                            />
                                        </div>

                                        <div className="col-span-3 sm:col-span-2 sm:pb-0">
                                            <div className="flex justify-end">
                                                <a
                                                    onClick={() => {
                                                        setType(0)
                                                    }}
                                                    type="button"
                                                    className="py-2 cursor-pointer px-4 flex items-center justify-center border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50"
                                                >
                                                    Cancel
                                                </a>

                                                <button
                                                    type="submit"
                                                    className="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white transition-colors bg-primary hover:bg-indigo-600"
                                                >
                                                    Save Changes
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
